import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { isTruthy } from "helpers/methods";

interface CustomProps {
  handleDialogClose: any;
  closable?: boolean;
  width?: string;
  height?: string;
  isDialogOpen: boolean;
  title?: JSX.Element;
  body: JSX.Element;
  footer?: JSX.Element;
  dialogFooterClass?: any;
  dialogBodyClass?: any;
  closeButtonVisibility?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  isNavsHide?: boolean;
  shouldeCloseOnOutsideClick?: boolean;
}

const CustomDialog = (props: CustomProps) => {
  const getDialogTitle = () => {
    return (
      <DialogTitle
        id="customized-dialog-title"
        sx={{
          display: "flex",
          padding: 2,
        }}
      >
        <>
          {isTruthy(props.title) && (
            <>
              <Box style={{ width: "100%" }}>{props.title}</Box>
            </>
          )}
          {props.closable && props.closeButtonVisibility && (
            <Box
              sx={{
                position: "absolute",
                top: "15px",
                right: "15px",
              }}
              onClick={props.handleDialogClose}
            >
              <IconButton aria-label="close" sx={{ p: 0.5, pt: 0 }}>
                <CloseIcon htmlColor="#475569" fontSize="small" />
              </IconButton>
            </Box>
          )}
        </>
      </DialogTitle>
    );
  };

  const getDialogBody = () => {
    return (
      <DialogContent
        sx={{
          padding: 2,
        }}
      >
        {props.body}
      </DialogContent>
    );
  };

  const getDialogFooter = () => {
    if (!isTruthy(props.footer)) {
      return null;
    }
    return (
      <DialogActions sx={{ justifyContent: "center", p: 2 }}>
        {props.footer}
      </DialogActions>
    );
  };

  const getDialog = () => {
    return (
      <>
        {getDialogTitle()}
        {getDialogBody()}
        {getDialogFooter()}
      </>
    );
  };

  return (
    <Dialog
      onClose={(event, reason) => {
        if (
          props.shouldeCloseOnOutsideClick &&
          (reason === "backdropClick" || reason === "escapeKeyDown")
        ) {
          return;
        }
        props.handleDialogClose();
      }}
      fullWidth
      maxWidth={props.maxWidth ?? "sm"}
      open={props.isDialogOpen}
      sx={{
        border: "1px solid rgba(71, 85, 105, 0.25)",
      }}
    >
      {getDialog()}
    </Dialog>
  );
};

CustomDialog.defaultProps = {
  shouldeCloseOnOutsideClick: false,
};

export default CustomDialog;
